/* eslint-disable quote-props */
const availableLanguages = [
    { id: 'ar_AR', ref: 'Arabic', name: 'العربية' },
    { id: 'bg_BG', ref: 'Bulgarian', name: 'БЪЛГАРСКИ' },
    { id: 'cs_CZ', ref: 'Czech', name: 'ČEŠTINA' },
    { id: 'da_DK', ref: 'Danish', name: 'DANSK' },
    { id: 'nl_NL', ref: 'Dutch', name: 'NEDERLANDS' },
    { id: 'en_GB', ref: 'English', name: 'ENGLISH' },
    { id: 'fr_FR', ref: 'French', name: 'FRANÇAIS' },
    { id: 'de_DE', ref: 'German', name: 'DEUTSCH' },
    { id: 'hu_HU', ref: 'Hungarian', name: 'MAGYAR' },
    { id: 'it_IT', ref: 'Italian', name: 'ITALIANO' },
    { id: 'no_NO', ref: 'Norwegian', name: 'NORSK' },
    { id: 'pl_PL', ref: 'Polish', name: 'POLSKI' },
    { id: 'pt_PT', ref: 'Portuguese', name: 'Português' },
    { id: 'pt_BR', ref: 'Brazilian Portugese', name: 'Português (Brasil)' },
    { id: 'ro_RO', ref: 'Romanian', name: 'ROMÂNĂ' },
    { id: 'ru_RU', ref: 'Russian', name: 'РУССКИЙ' },
    { id: 'es_ES', ref: 'Spanish', name: 'ESPAÑOL' },
    { id: 'es_LA', ref: 'Spanish', name: 'ESPAÑOL DE\nAMÉRICA LATINA' },
    { id: 'sv_SE', ref: 'Swedish', name: 'SVENSKA' },
    { id: 'tr_TR', ref: 'Turkish', name: 'TÜRKÇE' },
];

export type LanguageID = string;

const availableCountries = {
    // AFRICA
    SN: { region: 5, flag: 'senegal' },
    TN: { region: 5, flag: 'tunisia' },
    CG: { region: 5, flag: 'congo' },
    MA: { region: 5, flag: 'morocco' },
    BF: { region: 5, flag: 'burkina-faso' },
    CM: { region: 5, flag: 'cameroon' },
    GH: { region: 5, flag: 'ghana' },
    NG: { region: 5, flag: 'nigeria' },
    DZ: { region: 5, flag: 'algeria' },
    ZA: { region: 5, flag: 'south-africa' },
    KE: { region: 5, flag: 'kenya' },
    ET: { region: 5, flag: 'ethiopia' },
    AO: { region: 5, flag: 'angola' },
    ZM: { region: 5, flag: 'zambia' },
    RW: { region: 5, flag: 'rwanda' },

    // MIDDLE EAST
    EG: { region: 3, flag: 'egypt' },
    IR: { region: 3, flag: 'iran' },
    SA: { region: 3, flag: 'saudi-arabia' },
    AE: { region: 3, flag: 'united-arab-emirates' },
    QT: { region: 3, flag: 'qatar' },
    IQ: { region: 3, flag: 'iraq' },
    JO: { region: 3, flag: 'jordan' },
    LB: { region: 3, flag: 'lebanon' },

    // ASIA PACIFIC
    JP: { region: 6, flag: 'japan' },
    KR: { region: 6, flag: 'south-korea' },
    TH: { region: 6, flag: 'thailand' },
    CN: { region: 6, flag: 'china' },
    SG: { region: 6, flag: 'singapore' },
    MY: { region: 6, flag: 'malaysia' },
    TW: { region: 6, flag: 'taiwan' },
    LA: { region: 6, flag: 'laos' },
    VN: { region: 6, flag: 'vietnam' },
    PH: { region: 6, flag: 'philippines' },
    ID: { region: 6, flag: 'indonesia.png' },
    IN: { region: 6, flag: 'india' },
    PK: { region: 6, flag: 'pakistan' },
    AU: { region: 6, flag: 'australia' },
    NZ: { region: 6, flag: 'new-zealand' },

    // EASTERN EUROPE
    PL: { region: 4, flag: 'poland' },
    HR: { region: 4, flag: 'croatia' },
    SK: { region: 4, flag: 'slovakia' },
    AT: { region: 4, flag: 'austria' },
    UA: { region: 4, flag: 'ukraine' },
    RS: { region: 4, flag: 'serbia' },
    BA: { region: 4, flag: 'bosnia-herzegovina' },
    RO: { region: 4, flag: 'romania' },
    BG: { region: 4, flag: 'bulgaria' },
    ME: { region: 4, flag: 'montenegro' },
    GR: { region: 4, flag: 'greece' },
    CZ: { region: 4, flag: 'czech-republic' },
    HU: { region: 4, flag: 'hungary' },
    RU: { region: 4, flag: 'russia' },
    TR: { region: 4, flag: 'turkey' },

    // AMERICA
    US: { region: 2, flag: 'usa' },
    MX: { region: 2, flag: 'mexico' },
    CR: { region: 2, flag: 'costa-rica' },
    PA: { region: 2, flag: 'panama' },
    BR: { region: 2, flag: 'brazil' },
    AR: { region: 2, flag: 'argentina' },
    CL: { region: 2, flag: 'chile' },
    PE: { region: 2, flag: 'peru' },
    CO: { region: 2, flag: 'colombia' },
    UY: { region: 2, flag: 'uruguay' },
    PY: { region: 2, flag: 'paraguay' },
    BO: { region: 2, flag: 'bolivia' },
    VE: { region: 2, flag: 'venezuela' },
    EC: { region: 2, flag: 'ecuador' },

    // WESTERN EUROPE
    DE: { region: 1, flag: 'germany' },
    PT: { region: 1, flag: 'portugal' },
    BE: { region: 1, flag: 'belgium' },
    ES: { region: 1, flag: 'spain' },
    FR: { region: 1, flag: 'france' },
    DK: { region: 1, flag: 'denmark' },
    IT: { region: 1, flag: 'italy' },
    GB: { region: 1, flag: 'england' },
    SE: { region: 1, flag: 'sweden' },
    WA: { region: 1, flag: 'wales' },
    NL: { region: 1, flag: 'netherlands' },
    IX: { region: 1, flag: 'northern-ireland' },
    IE: { region: 1, flag: 'ireland' },
    SC: { region: 1, flag: 'scotland' },
    NO: { region: 1, flag: 'norway' },

    // MISC
    WS: { region: 0, flag: 'allstar-1' },
};

export function getMostSuitableLanguage(id: string): LanguageID
{
    // Check if given id matches one of the available languges
    for (const item of availableLanguages)
    {
        if (item.id === id)
        {
            return item.id;
        }
    }

    // If given id does not match, check if at least first element matches one of the available languages
    // Example: en_US does not match exactly any of listed languages, but en_GB is the most suitable replacement
    const languageId = getFirstElement(id);

    for (const item of availableLanguages)
    {
        if (item.id.startsWith(languageId))
        {
            return item.id;
        }
    }

    return '';
}

export function getLanguageNativeName(languageId: LanguageID): string
{
    for (const item of availableLanguages) if (item.id === languageId) return item.name;

    return '';
}

export function getAvailableLanguages(): LanguageID[]
{
    return availableLanguages.map((item) => item.id) as LanguageID[];
}

export function isLanguageAvailable(lang: string): boolean
{
    for (const item of availableLanguages)
    {
        if (item.id === lang) return true;
    }

    return false;
}

export function getCountryFlag(id: string): string
{
    const countryId = getSecondElement(id);
    const country = availableCountries[countryId as keyof typeof availableCountries];

    return country ? country.flag : 'allstar-1';
}

/** Get the first element of a language id. Ex: `en_GB` will return `en` */
function getFirstElement(languageId: string): string
{
    return (languageId.split('_').shift() as string).toLowerCase();
}

/** Get the second element of a language id. Ex: `en_GB` will return `GB` */
function getSecondElement(languageId: string): string
{
    return (languageId.split('_').pop() as string).toUpperCase();
}
